import { useTranslation } from 'react-i18next';
import { SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

import { CountryCode } from 'lib/constants/locales';
import { AddressAutocompleteMethod, InputField } from 'lib/interfaces/verificationConfig';
import ThemedParagraph from 'verify/components/ThemedParagraph';
import ThemedTitle from 'verify/components/ThemedTitle';
import FormDatabase from 'verify/forms/FormDatabase';
import { DatabaseFormData } from 'verify/forms/FormDatabase/FormDatabase';
import { HolderClient } from 'verify/lib/clients/HolderClient';
import { MIN_HEIGHTS } from 'verify/styles/variables';

const Header = styled('div')`
  min-height: ${MIN_HEIGHTS.header};
  margin-bottom: ${SPACINGS.base * 4}px;
`;

interface VerifyDatabaseProps {
  changeFormValue: (form: string, field: string, value: string) => void;
  selectedCountryCode: CountryCode;
  handleSubmit: (values: DatabaseFormData) => Promise<void>;
  latLng: google.maps.LatLngLiteral;
  inputFields: InputField[];
  isProcessing: boolean;
  hasSubmittedValues: boolean;
  addressAutocompleteMethod: AddressAutocompleteMethod;
}

export default function VerifyDatabaseView(props: VerifyDatabaseProps) {
  const [t] = useTranslation();

  return (
    <div>
      {props.hasSubmittedValues &&
      props.inputFields.length === 1 &&
      props.inputFields[0] === InputField.IdentificationNumberFull9 ? (
        <Header>
          <ThemedTitle>{t('database.title-retry')}</ThemedTitle>
          <ThemedParagraph>{t('database.prompt-retry')}</ThemedParagraph>
        </Header>
      ) : (
        <Header>
          <ThemedTitle>{t('database.title')}</ThemedTitle>
          <ThemedParagraph>{t('database.prompt')}</ThemedParagraph>
        </Header>
      )}

      <FormDatabase
        changeFormValue={props.changeFormValue}
        selectedCountryCode={props.selectedCountryCode}
        latLng={props.latLng}
        lockedAttributes={
          props.hasSubmittedValues ? undefined : HolderClient.inquiryParams['locked-attributes']
        }
        onSubmit={props.handleSubmit}
        inputFields={props.inputFields}
        isProcessing={props.isProcessing}
        addressAutocompleteMethod={props.addressAutocompleteMethod}
      />
    </div>
  );
}
